/* global LP, $ */
import apiRequest from 'js/common/api_request';

const { LP } = window;

export const submitData = (data, edit, url) => {
  const { collection_id, title, body } = data;
  const params = {
    page_resource: {
      title,
      body,
      collection_id
    }
  };
  const method = edit ? 'put' : 'post';
  const path = edit ? url : `${LP.config.page_resources_path}.json`;
  const response = apiRequest[method](path, params)
    .then(({ data: [message, item] }) => {
      $(document).trigger('ajax:success:item', [[message, item]]);
      return item;
    })
    .catch((error) => {
      const { data: err, status } = error.response;
      const statuses = [401, 403, 404];
      if (statuses.includes(status)) {
        LP.module('Collections').EditCollectionItemsArea.handleServerError({
          status,
          err
        });
      }
    });
  return response;
};

export async function getPageItemDetails(url) {
  const response = await apiRequest.get(`${url}/edit.json`);
  const data = await response.data;
  return data;
}
